import React from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from "./Breadcrumbs";
import useSeo from "../hooks/useSeo";

/** Shared shell for the legal/policy pages so they all read the same way. */
export default function PolicyPage({ title, updated, intro, seoDescription, slug, children }) {
  useSeo({ title: `${title} - NQ Springs & 4x4 Accessories`, description: seoDescription, canonical: `/${slug}` });

  return (
    <div data-testid={`policy-page-${slug}`}>
      <section
        className="border-b"
        style={{ borderColor: "rgba(255,255,255,0.08)", background: "var(--nq-ink)" }}
      >
        <div className="container-nq py-10">
          <Breadcrumbs items={[{ slug, label: title }]} />
          <p className="eyebrow mt-4">Policies</p>
          <h1 className="mt-2 text-3xl font-bold md:text-5xl">{title}</h1>
          {intro && (
            <p className="mt-3 max-w-3xl text-sm leading-relaxed text-[color:var(--nq-stone)] md:text-base">
              {intro}
            </p>
          )}
          <p className="mt-4 text-xs text-[color:var(--nq-stone)]">Last updated {updated}</p>
        </div>
      </section>

      <div className="container-nq section-nq">
        <div className="policy-prose max-w-3xl space-y-8">{children}</div>

        <div
          className="mt-12 max-w-3xl rounded-xl border p-5 text-sm"
          style={{ borderColor: "rgba(198,162,74,0.28)", background: "rgba(198,162,74,0.06)" }}
        >
          <p className="font-semibold">Questions about this policy?</p>
          <p className="mt-1 text-[color:var(--nq-stone)]">
            Ring the shop on{" "}
            <a href="tel:0747748859" className="gold-text font-semibold">(07) 4774 8859</a>, email{" "}
            <a href="mailto:info@nqsprings.com.au" className="gold-text font-semibold">info@nqsprings.com.au</a>{" "}
            or use the <Link to="/contact-us" className="gold-text font-semibold">contact form</Link>.
          </p>
        </div>
      </div>
    </div>
  );
}

export const H2 = ({ children }) => (
  <h2 className="text-base font-bold uppercase tracking-[0.12em] gold-text md:text-lg">{children}</h2>
);

export const P = ({ children }) => (
  <p className="mt-2 text-sm leading-relaxed text-[color:var(--nq-stone)]">{children}</p>
);

export const UL = ({ children }) => (
  <ul className="mt-3 space-y-2 text-sm leading-relaxed text-[color:var(--nq-stone)]">{children}</ul>
);

export const LI = ({ children }) => (
  <li className="flex gap-2">
    <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full" style={{ background: "var(--nq-gold)" }} />
    <span>{children}</span>
  </li>
);
